import React, { useContext } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import clsx from 'clsx';
import { formatOdds } from '@/common/client';
import PropTypes from 'prop-types';
import { togglePick } from '@/betslip/handlers';
import BetLocationContext from 'nike-ui/src/common/BetLocationContext';
import { getPickId, isPickSelected$$ } from 'nike-ui/src/components/betslip/subs';

const BannersSelectionRow = React.memo(function BannersSelectionRow({ betId, editorTip, onHeightUpdate, showLoader }) {
    const derefSub = useReframe();
    const betBanner = derefSub(['sub:betbanners/by-bet-number', betId]);
    //null === z api sa nevratili data pre dany betId (empty)
    const emptyBanner = betBanner === null || (betBanner && !betBanner.get('selections'));

    React.useEffect(
        function handleHeightUpdate() {
            if (onHeightUpdate && emptyBanner) {
                onHeightUpdate();
            }
        },
        [onHeightUpdate, emptyBanner]
    );

    //undefined === data sa este nevratili
    if (showLoader && betBanner === undefined) {
        return <BannersSelectionRowLoader />;
    }

    //loader sme preskocili ale data nemame
    if (!betBanner) {
        return null;
    }
    return (
        <div className="BannersSelectionRow">
            {betBanner.get('selections').map((selection, index) => {
                if (selection.get('code') === '51') {
                    return null;
                }
                return (
                    <BannersSelection
                        key={selection.get('code')}
                        betNumber={betBanner.get('infoNumber')}
                        betId={betBanner.get('betId')}
                        code={selection.get('code')}
                        header={selection.get('headerBanner')}
                        odds={selection.get('odds')}
                        editorTip={String(index + 1) === editorTip}
                    />
                );
            })}
        </div>
    );
});
BannersSelectionRow.propTypes = {
    betId: PropTypes.any,
    editorTip: PropTypes.any,
    onHeightUpdate: PropTypes.any,
    showLoader: PropTypes.bool
};

function BannersSelectionRowLoader() {
    return <div className="BannersSelectionRowLoader wave-animation" />;
}

function BannersSelection({ betId, odds, header, betNumber, code, editorTip }) {
    const betLocationContext = useContext(BetLocationContext);
    const { subscribe } = useReframe();
    const { isSelected } = subscribe(isPickSelected$$(getPickId(betId, code)));
    const positionId = betLocationContext?.betLocationSection.id;
    const positionCode = betLocationContext?.betLocationSection.code;

    const handleClick = React.useCallback(
        function handleClick(event) {
            event.preventDefault();
            event.stopPropagation();

            if (odds > 1) {
                dispatch(
                    togglePick({
                        betId,
                        selectionCode: code,
                        odds,
                        infoNumber: betNumber,
                        positionId,
                        positionCode
                    })
                );
            }
        },
        [odds, betId, code, betNumber, positionId, positionCode]
    );

    return (
        <div
            onClick={handleClick}
            data-atid="hp-module-banner-bets"
            className={clsx('BannersSelection', 'ripple', { selected: isSelected }, { editorTip })}
        >
            {isSelected}
            <div className="header">{header}</div>
            {odds > 1 ? (
                <div className="odds">{formatOdds(odds)}</div>
            ) : (
                <div className="locked">
                    <div className="lock-image" />
                </div>
            )}
        </div>
    );
}

export default BannersSelectionRow;
